
export default {
  data() {
    return {
      tahun : '',
      list_tahun : [],
      list_output : [],
      list_outcome : [],
      total_target : 0,
      total_unggah : 0,
      total_selesai : 0,
    }
  },
  methods: {

    getTahun : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Tahun, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.list_tahun = res_data;
                this.$store.commit("hideLoading");
        });
      },

    getOutput : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Beranda + "output", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                tahun : this.tahun
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_output = res_data.data;
                this.$store.commit("hideLoading");
        });
      },

      getOutcome : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Beranda + "outcome", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                tahun : this.tahun
            })
        })
            .then(res => res.json())
            .then(res_data => {
              console.log(res_data.data);
              
                this.list_outcome = res_data.data;
                this.$store.commit("hideLoading");
        });
      },

      getTotal : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_Beranda + "total", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                tahun : this.tahun
            })
        })
            .then(res => res.json())
            .then(res_data => {
              console.log(res_data);
              
                this.total_target = res_data.data[0].total_target;
                this.total_selesai = res_data.data[0].total_selesai;
                this.total_unggah = res_data.data[0].total_unggah;
                this.$store.commit("hideLoading");
        });
      },

  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.unitKerja = get_profile.profile.unit_kerja_id;
    console.log(this.unitKerja);
    this.getOutput();
    this.getOutcome();
    this.getTahun();
    this.getTotal();
  },
}
